import { createAction, props } from '@ngrx/store';

import { ShoppingCartDto } from '../core/dtos/dto';

export const loadShoppingCart = createAction('[Shopping Cart] Load Shopping Cart', props<{ shoppingCart: ShoppingCartDto }>());

export const clearShoppingCart = createAction('[Shopping Cart] Clear Shopping Cart');
